
interface Props {
  align?: string
  specialties: Array<{
    id: number
    name: string
    image: string | null
  }>
}

export default function Specialties({ specialties }: Props) {
  return (
    <div className="w-full text-base font-normal">
      {specialties?.length > 0 ? (
        <ul className="space-y-3">
          {specialties.map((specialty, index) => (
            <li
              key={specialty.id}
              className="text-base font-normal"
            >
              {String(index + 1).padStart(2, '0')}. {specialty.name}
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-center">No Specialties Found</p>
      )}
    </div>
  )
}
